import mixpanel from 'mixpanel-browser';
import configuration from './../configuration/server';

export function initializeMixpanel() {
    const { STAGE } = configuration;
    const { key } = configuration[STAGE].mixpanel;

    mixpanel.init(key);
    if (STAGE === 'local') {
        mixpanel.set_config({ debug: true });
    }
}



// WEBPACK FOOTER //
// ./src/utilities/mixpanel.jsx